// Module
var code = "<template>\n    <button type=\"button\" \n        class=\"btn btn-success\" \n        resource=\"RowGeneratorParameterEdit_Button_ApplyChanges\"\n        click.delegate=\"applyParameterChanges()\">\n    </button>\n</template>\n";
// Exports
export default code;